export function convertNullToUndefined(obj: any) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === null) {
      obj[key] = undefined;
    }
  }
  return obj;
}
